import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto">
      <div className="bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-0">
            <div className="flex items-center gap-2 order-1 md:order-1">
              <span className="text-sm md:text-base">© 2025 rent.reviews</span>
              <span className="text-xs opacity-50">V2.1</span>
            </div>
            <div className="order-2 md:order-2">
              <a href="mailto:info@rentreview.io" className="hover:text-gray-300 transition-colors text-sm md:text-base">
                info@rentreview.io
              </a>
            </div>
            <div className="order-3 md:order-3">
              <Link to="/privacy-policy" className="text-blue-400 hover:text-blue-300 transition-colors text-sm md:text-base">
                Privacy Policy
              </Link>
              <span className="mx-2 text-gray-500">|</span>
              <Link to="/cookies-policy" className="text-blue-400 hover:text-blue-300 transition-colors text-sm md:text-base">
                Cookies Policy
              </Link>
              <span className="mx-2 text-gray-500">|</span>
              <Link to="/terms-conditions" className="text-blue-400 hover:text-blue-300 transition-colors text-sm md:text-base">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}